
import { createSearchModel } from './searchModel'
import { html as dom, empty } from './../utility/html'
import naturalLanguageJoin from './../utility/naturalLanguageJoin'


// components

function jobs(el, jobs, limit = 10) {
	if (jobs.length) {
		el.innerHTML = ''
		jobs.slice(0, limit).map(data => el.appendChild(job(data)))
	} else {
		el.innerHTML = `
			<div class="padding-bottom-2 page-width">
				<h2 class="heading-3 margin-top-0">No jobs found</h2>
				<p>We couldn’t find any results for your search.</p>
			</div>
		`
	}
}

function job({ applyUrl, title, jobType, location, sector, internalLink, internal }) {

	const locations = (location.length > 3) ? 'Multiple locations' : naturalLanguageJoin(location, 'or')
	const sectors = (sector.length > 3) ? 'Across multiple sectors' : naturalLanguageJoin(sector)
	const locationText = [locations, sectors].filter(Boolean).join(' — ')
	const link = internal ? internalLink : applyUrl

	return dom(`
		<a target="_blank" rel="noopener noreferrer" href="${link}" class="job-tile job-tile--button">
			<div class="job-tile__title">${title}</div>
			<div class="job-tile__sub">
				${ jobType && `<div class="job-tile__sub__item">${ jobType }</div>` || "" }
				${ locations && `<div class="job-tile__sub__item"><i class="icon icon--location-pin"></i>${ locations }</div>` || "" }
			</div>
			<div class="job-tile__button button button--outline button--auto">Apply now</div>
		</a>
	`)
}

function status(el, { type, subject, location, jobCount, limit = 10 }) {
	const text = []
	if (subject.length) text.push(`in <span class="text-highlight">${subject[0]}</span>`)
	if (location.length) text.push(`in <span class="text-highlight">${location[0]}</span>`)
	if (type.length) text.push(`in <span class="text-highlight">${type[0]}</span>`)

	let showing = Math.min(jobCount, limit)
	let countText = (showing === jobCount) 
		? `${showing > 2 ? 'All' : ''} <strong>${showing}</strong> ${jobCount === 1 ? 'opening' : 'openings' } ${text.join(' ')}`
		: `Showing <strong>${showing}</strong> of <strong>${jobCount}</strong> ${jobCount === 1 ? 'opening' : 'openings' } ${text.join(' ')}`

	el.innerHTML = ''
	el.appendChild(dom(countText))
}


function register(el, data, model) {

	if (!data) return

	const { title, content, link } = data
	const jobs = model.get('jobs')
	
	el.innerHTML = ''

	if (jobs.length) return

	el.appendChild(
		dom(`
		<div class="pullout-box pullout-box--button-right margin-bottom-0">
			${title && `<h2 class="pullout-box__heading">${title}</h2>` || '' }
			${content && `<div class="body-text--small">${content}</div>` || ''}
			${link.text && link.href && `<a ${link.target} href="${link.href}" class="pullout-box__button button button--outline button--block@medium-max">${link.text}</a>` || '' }
		</div>
		`)
	)
}

function button(el, model, limit = 10) {

	const url = model.searchUrl()
	const jobs = model.get('jobs')
	const jobsCount = jobs.length || 0

	el.innerHTML = ''
	if (!jobsCount) return
	if (jobsCount <= limit) return

	el.appendChild(dom(`<a href="${url}" class="button margin-top-2 button--block@medium-max">View all <strong>${jobs.length}</strong> openings</a>`))
}


const setup = (el) => {

	const formEl = el.querySelector('.js-search-module__form')
	const statusEl = el.querySelector('.js-search-module__status')
	const jobsEl = el.querySelector('.js-search-module__jobs')
	const buttonEl = el.querySelector('.js-search-module__button')
	const registerEl = el.querySelector('.js-search-module__register')

	const registerData = JSON.parse(el.getAttribute('data-register'))
	
	if (!formEl) return

	// model
	const model = createSearchModel(formEl)

	const render = (key, value, triggeredBy) => {
		if (key === 'jobs') {
			jobs(jobsEl, model.get('jobs') || [], 10)
			status(statusEl, {
				type : model.get('jobType'),
				subject : model.get('subject'),
				location : model.get('location'),
				jobCount : (model.get('jobs') || []).length,
				limit : 10
			})
			register(registerEl, registerData, model)
			button(buttonEl, model, 10)
		}
		

		if (key === 'loading') {
			if (value) {
				jobsEl.classList.add('js-loading')
			} else {
				jobsEl.classList.remove('js-loading')
			}
		}
	}

	model.subscribe(({ key, value, triggeredBy }) => render(key, value, triggeredBy))
	model.run()

	// events

	formEl.addEventListener('submit', event => {
		event.preventDefault()
		model.run()
	})

	const selects = [...formEl.querySelectorAll('select')]
	selects.map(select => {
		select.addEventListener('change', event => {
			model.set(event.currentTarget.name.replace(/\[\]$/, ''), event.currentTarget.value && [event.currentTarget.value])
		})
	})
}


export default function init() {
	const form = [...document.querySelectorAll('.js-search-module')]
	form.map(setup)
}